<div class="export-epg-screen-container">
  <div class="export-epg-screen">
    <h1>Export as Run Log</h1>
    <h2>Please select your export preferences</h2>

    <div class="date-picker-epg-container">
      <label class="epg-option"> SELECT DATE RANGE: </label>
      <div class="date-picker-epg-content">
        <label class="epg-option-inline">From: </label>
        <dateinput
          [(current)]="startDate"
          (currentChange)="changeStartDate($event)"
        ></dateinput>
        <label class="epg-option-inline">To: </label>
        <dateinput
          [(current)]="endDate"
          (currentChange)="changeEndDate($event)"
        ></dateinput>
      </div>
    </div>

    <div class="media-duration-container">
      <label class="epg-option-inline epg-option">SELECT CHANNEL: </label>
      <icn-dropdown
        [selectedValue]="channelChosen"
        [listDown]="true"
        (selectedValueChange)="onChannelChosenChanged($event)"
      >
        <icn-dropdown-item
          *ngFor="let channel of channels"
          [title]="channel.name"
          [value]="channel"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="platforms-export-container" *ngIf="!exportAsMarinaXml">
      <label class="epg-option"> EXPORT PLATFORM: </label>
      <icn-dropdown
        class="export-platforms-dropdown"
        [selectedValue]="exportConfigurationChosen"
        (selectedValueChange)="onSelectedExportConfigurationChange($event, platformsPopover)"
      >
        <icn-dropdown-item
          *ngFor="let configuration of exportConfigurations"
          [title]="configuration.name"
          [value]="configuration"
        >
        </icn-dropdown-item>
      </icn-dropdown>
      <div
        class="svg-icon-export"
        inlineSVG="/assets/icons/add-account.svg"
        (click)="onClickAddPlatform($event, platformsPopover)"
      ></div>
      <pop-over #platformsPopover [my]="'left'" [at]="'left'" [x-offset]="60">
        <icn-export-platforms
          (addedExportConfiguration)="onAddedExportConfiguration($event,platformsPopover)"
          (updatedExportConfiguration)="onUpdatedExportConfiguration($event,platformsPopover)"
          (close)="onPlatformsClose(platformsPopover)"
        ></icn-export-platforms>
      </pop-over>
    </div>
    <div class="exportAsRunField">
      <label class="epg-option"> EXPORT AS MARINA XML</label>
      <evrideo-checkbox
        class="chkExportAsMarinaXml cursorPointer"
        (activeChange)="onExportAsMarinaXmlChecked($event)"
      ></evrideo-checkbox>
    </div>
    <a class="btn btn-export" (click)="exportRunLog()" download>Export</a>
  </div>
</div>
